import { hideElement } from "../../../utils";
import { constants } from "../common";
import { alertBoxTimeout } from "./showBasketAlertBox";

const { basketAlert, basketUpgrade } = constants.selectors;

export function hideBasketAlertBox() {
  const basketAlertElement = document.querySelector(basketAlert);
  if (!basketAlertElement) {
    console.warn("Basket alerts not supported on current page.");
    return;
  }

  const upgradeNoticeElement = basketAlertElement.querySelector(basketUpgrade);

  hideElement(basketAlertElement);
  hideElement(upgradeNoticeElement);
  if (alertBoxTimeout) {
    clearTimeout(alertBoxTimeout);
  }
}
